export const SITE_URL = "https://lifebasicsguide.com";
export const SITE_NAME = "Life Basics Guide";
export const DEFAULT_TITLE = `${SITE_NAME} - Life Skills You Were Never Taught`;
export const DEFAULT_DESCRIPTION = "Clear, practical guidance for adults. No judgment, no fluff—just the information you need to handle everyday tasks with confidence.";
export const DEFAULT_OG_IMAGE = "/og-image.png";

// OG Image dimensions - optimized for all platforms and Google Discover
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;
export const MIN_DISCOVER_IMAGE_WIDTH = 1200;

// Logo for structured data (JSON-LD) — must be at least 112x112px
// Replace with a dedicated square logo when available
export const SITE_LOGO = `${SITE_URL}/og-image.png`;
export const SITE_LOGO_WIDTH = 1200;
export const SITE_LOGO_HEIGHT = 630;

export const getCanonicalUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${cleanPath}`;
};

export const getOgImageUrl = (image?: string): string => {
  if (!image) return `${SITE_URL}${DEFAULT_OG_IMAGE}`;
  if (image.startsWith('http')) return image;
  return `${SITE_URL}${image.startsWith('/') ? image : `/${image}`}`;
};

// Helper to check if image meets Discover requirements
export const isDiscoverOptimalImage = (width: number): boolean => {
  return width >= MIN_DISCOVER_IMAGE_WIDTH;
};
